import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button, Divider } from 'antd'

import { Queries } from 'admin/lib/Api'
import { Select } from 'admin/lib/Forms'

/**
 * @param {{ scope: 'user'|'global' }} param0
 */
function AccountSelectInner(
  { value, onChange, scope = 'user', disabled },
  ref
) {
  const accounts = Queries.useAccounts({ scope })

  const options = useMemo(() => {
    return accounts.data?.map(account => ({
      'value': account.accountId,
      'label': account.name,
      'aria-label': account.name
    }))
  }, [accounts.data])

  const handleSelectAll = useCallback(() => {
    if (onChange && accounts.data) {
      onChange(accounts.data.map(account => account.accountId))
    }
  }, [onChange, accounts.data])

  const handleClearAll = useCallback(() => {
    if (onChange) {
      onChange([])
    }
  }, [onChange])

  const isDisabled = disabled || accounts.isFetching

  return (
    <Select
      loading={accounts.isFetching && !accounts.isFetched}
      disabled={disabled || (accounts.isFetching && !accounts.isFetched)}
      mode="multiple"
      allowClear
      showSearch
      options={options}
      value={value || []}
      onChange={onChange}
      ref={ref}
      popupRender={menu => (
        <div>
          {menu}
          <Divider style={{ margin: '4px 0' }} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Button
              type="primary"
              block
              onClick={handleSelectAll}
              disabled={isDisabled}
              style={{
                margin: '0.5rem'
              }}
            >
              Select All
            </Button>
            <Button
              block
              onClick={handleClearAll}
              disabled={isDisabled}
              style={{
                margin: '0.5rem'
              }}
            >
              Clear All
            </Button>
          </div>
        </div>
      )}
    />
  )
}

export const AccountSelect = React.memo(React.forwardRef(AccountSelectInner))

AccountSelectInner.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  scope: PropTypes.oneOf(['global', 'user']),
  disabled: PropTypes.bool
}
